"use client";

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import { useUser } from '../context/UserContext';
import Sidebar from '../components/layout/Sidebar';
import MobileNavigation from '../components/layout/MobileNavigation';

export default function AccountLayout({ children }) {
  const { isAuthenticated, loading } = useUser();
  const router = useRouter();
  
  // Redirect to home if not authenticated
  useEffect(() => {
    if (!loading && !isAuthenticated) {
      router.push('/');
    }
  }, [isAuthenticated, loading, router]);
  
  if (loading) {
    return (
      <div className="flex min-h-screen bg-gray-50 justify-center items-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  // Don't render anything until we're sure the user is authenticated
  if (!isAuthenticated) {
    return null;
  }
  
  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar mobileOpen={false} setMobileOpen={() => {}} />
      
      {/* Main Content */}
      <div className="flex-1 min-h-screen flex flex-col">
        {/* Account Navigation */}
        <div className="bg-white shadow-sm border-b">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16">
              <div className="flex">
                <div className="flex-shrink-0 flex items-center">
                  <h1 className="text-xl font-bold text-gray-900">My Account</h1>
                </div>
                <nav className="hidden sm:ml-6 sm:flex sm:space-x-8">
                  <Link 
                    href="/account/profile"
                    className={`inline-flex items-center px-1 pt-1 border-b-2 ${
                      window.location.pathname === '/account/profile' 
                        ? 'border-primary text-gray-900' 
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                    } text-sm font-medium`}
                  >
                    Profile
                  </Link>
                  <Link 
                    href="/account/addresses"
                    className={`inline-flex items-center px-1 pt-1 border-b-2 ${
                      window.location.pathname === '/account/addresses' 
                        ? 'border-primary text-gray-900' 
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                    } text-sm font-medium`}
                  >
                    Addresses
                  </Link>
                  <Link 
                    href="/orders"
                    className={`inline-flex items-center px-1 pt-1 border-b-2 ${
                      window.location.pathname === '/orders' 
                        ? 'border-primary text-gray-900' 
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                    } text-sm font-medium`}
                  >
                    Orders
                  </Link>
                </nav>
              </div>
            </div>
          </div>
        </div>
        
        {/* Page Content */}
        <main className="flex-1 py-6 px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </main>
      </div>
      
      {/* Mobile Navigation */}
      <MobileNavigation />
    </div>
  );
} 